import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useBookingService from "../../api/services/useBookingService";
import BookingItemDetail from "../../components/BookingItemDetail/BookingItemDetail";
import useInvoiceService from "../../api/services/useInvoiceService";
import useFunction from "../../hooks/useFunction";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";


const UserBooking = () => {

  const {userShow, userAction} = useBookingService()
  const [isLoading, setIsLoading] = useState(true)
  const {bookingId} = useParams();
  const [booking, setBooking] = useState(null)
  const navigate = useNavigate()
  const {c} = useFunction()
  const {handleStreamBookingInvoicePdf, handleStreamBookingReceiptPdf} = useInvoiceService()

  useEffect(() => {
    loadBooking(bookingId)
  }, [])

  const callbackConfirm = (booking, action, denyReason) => {
    setIsLoading(true)
    userAction(
      (booking) => {

        /*
         * Action remove
         */
        if (action === 'remove') {
          navigate('/user/boekingen')
        } else {

          /*
           * Action cancel-request
           */
          //todo use more nice method...
          loadBooking(bookingId)
        }
        setIsLoading(false)
      },
      (error) => {
        c('booking update error', error)
      },
      booking.id,
      {
        action: action,
        deny_reason: denyReason,
      },
    )
  }

  /**
   * Load booking
   */
  const loadBooking = (bookingId) => {
    !isLoading && setIsLoading(true)

    userShow(
      (booking) => {
        setBooking(booking)
        setIsLoading(false)
      },
      () => {
        //todo
      },
      bookingId
    )
  }

  return (
    <div className="page-user-booking">
      <h1>Boeking</h1>
      <div className="row">
        <Button
          label="Alle boekingen"
          onClick={() => navigate('/user/boekingen')}
        />
        {!isLoading && //
          <>
            <div className="top-right">
              {booking.active_user_pays &&
                <>
                  {!!booking.active_user_payments.length &&
                    <Button
                      label="Betalingen"
                      link={'/user/betalingen/boeking/' + bookingId}
                    />
                  }
                  {!!booking.active_user_invoices.length
                    ?
                    <Button
                      label="Download factuur"
                      onClick={() => handleStreamBookingInvoicePdf(bookingId)}
                      debounce={3000}
                      target="_blank"
                    />
                    :
                    <>
                    </>
                  }
                </>
              }
              {booking.active_user_gets_paid &&
                <>
                  {!!booking.active_user_outgoing_payments.length &&
                    <Button
                      label="Uitbetalingen"
                      link={'/user/bonnen/boeking/' + bookingId}
                    />
                  }

                  {!!booking.active_user_receipts.length
                    ? <Button
                      label="Download bon"
                      onClick={() => handleStreamBookingReceiptPdf(bookingId)}
                      debounce={3000}
                      target="_blank"
                    />
                    :
                    <>
                    </>
                  }
                </>
              }
              <FeedbackPopup
                location="/user/boeking/{id}"
              />
            </div>
          </>
        }
      </div>
      {isLoading
        ? <Loading/>
        : <BookingItemDetail booking={booking} callbackConfirm={callbackConfirm}/>
      }
    </div>
  )
}

export default UserBooking
